export enum Permission {
  View = 'view',
  Create = 'create',
  Edit = 'edit',
  Remove = 'remove',
}
